import { mixins, styled } from '@bob/library'
import { Link } from 'gatsby'

export interface FixedWrapperProps {
  position: 'fixed' | 'absolute' | 'relative'
  width: number
  left: number
  top: number
}

export const BOTTOM_SPACING = 10

export const Wrapper = styled.div`
  margin-top: 20px;
  @media print {
    display: none;
  }
`

export const Title = styled.h2`
  ${mixins.typography.headlineMedium}
  color: ${({ theme }) => theme.color.secondary};
  ${mixins.margin.top(30)}
  ${mixins.margin.bottom(30)}
`

export const Subtitle = styled.h3`
  ${mixins.typography.headlineXxs}
  ${mixins.margin.top(5)}
  ${mixins.margin.bottom(15)}
  color: ${({ theme }) => theme.color.secondary};
`

export const FixedWrapper = styled.div<FixedWrapperProps>`
  background-color: ${({ theme }) => theme.background.secondary};
  color: ${({ theme }) => theme.color.secondary};
  padding: 20px 15px;
  position: ${({ position }) => position};
  top: ${({ position, top }) => (position === 'fixed' ? `${top}px` : 'auto')};
  left: ${({ position, left }) => (position === 'fixed' ? `${left}px` : 'auto')};
  width: ${({ position, width }) => (position !== 'relative' ? `${width}px` : 'auto')};
  bottom: ${({ position }) => (position === 'absolute' ? `${BOTTOM_SPACING}px` : 'auto')};
  right: ${({ position }) => (position === 'absolute' ? 0 : 'auto')};
`

export const Content = styled.div`
  border-top: 1px solid ${({ theme }) => theme.color.secondary};
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  & > a {
    ${mixins.padding.left(0)}
  }
`

export const ContentDescription = styled.p`
  ${mixins.typography.noColor.subtitleSmall}
`

export const ContentActions = styled.div`
  padding: 20px 0;
  display: flex;
  margin: 0 auto;
`

export const GoogleImage = styled.img`
  width: 48px;
  height: 48px;
  ${mixins.margin.right(10)}
`

export const DownloadSW = styled.a`
  ${mixins.cta.primary('white')};
`

export const ViewSW = styled(Link)`
  ${mixins.cta.primary('white')};
`

export const ButtonHyperlink = styled.a`
  ${mixins.cta.hyperlink('white')}
`
